export const buttonSizeProperty = {
  Large: {
    padding: "0px 28px",
    height: "56px",
    width: "200px",
    gap: "8px",
    fontSize: "16px",
    lineHeight: "24px",
    iconWidth: "24px",
    iconHeight: "24px"
  },
  Medium: {
    padding: "0px 20px",
    height: "44px",
    width: "160px",
    gap: "8px",
    fontSize: "14px",
    lineHeight: "21px",
    iconWidth: "24px",
    iconHeight: "24px"
  },
  Small: {
    padding: "0px 16px",
    height: "34px",
    width: "116px",
    gap: "4px",
    fontSize: "12px",
    lineHeight: "18px",
    iconWidth: "16px",
    iconHeight: "16px"
  }
};
